module.exports = __webpack_public_path__ + "img/5.1f68a41a.png";